import React, { useEffect } from 'react'
import { useState } from 'react'
import { Box, Button, Checkbox, Divider, FormControlLabel, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import Modal from '../../../common/modal'
import DropDownOA from '../../../common/dropDownOA'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import { getApprAuthority } from '../constants'
import InfoIcon from '@mui/icons-material/Info'
import SuccessfullModal from "../../../common/SuccessfullModal"
import SuccessAndErrorModal from "../../../common/SuccessAndErrorModal"
import { focusElemnt, navigation3 } from '../../../common/helper'
import { updateAlertError, updateModal, userRollRightEditRights } from '../../../../store/common/common_action'
import { connect } from 'react-redux'
import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material'
import OTPModal from './OTPModal'
import {userRREditRightsSave } from '../../../../store/branchAndUserMaster/BUMAction'
import { oTPForUserRoleRight } from '../../../common/jotaiState/commonStateAtoms'
import { useTranslation } from '../../../../i18n/I18nProvider'
const EditRightsModal = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const ApprAuthority = getApprAuthority(translations)
    const { data, updateModal, updateAlertError, userRollRightSendOTP, userRREditRightsSave, editRightsData, roleId, otpOnUserRights,onLoad,userRollRightEditRights,loginData } = props
    const { common } = data
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const [OtpModal, setOtpModal] = useState(false)
    const [OTP, setOTP] = useState("")
    const [selApprAuth, setSelApprAuth] = useState("")
    const [showData, setShowData] = useState([])
    const [showSubData, setShowSubData] = useState("")
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const [saveError, setSaveError] = useState({ error: false, message: "", })


    useEffect(() => {
        focusElemnt("EditRightsAppAuth")
    }, [])

    useEffect(() => {
        if (editRightsData?.length > 0) {
            setShowData(editRightsData)
        } else {
            setShowData([])
        }
    }, [editRightsData])

    const rightClick = (i) => {
        if (showSubData == i + 1) {
            setShowSubData(0)
        } else {
            setShowSubData(i + 1)
        }
    }
    const arrowClick = (event, nextId, prevId, callFunction) => {
        if (event.key === 'Enter') {
            focusElemnt(nextId)
        } else if (event.key === 'Escape') {
            focusElemnt(prevId)
        } else if (event.keyCode === 32 || event.keyCode === ' ') {
            callFunction()
        }
    }

    const subDataHandleChange = (value, index, subIndex) => {
        const updatedShowData = [...showData];
        const updatedItem = { ...updatedShowData[index] };
        const updatedSubData = [...updatedItem.subData];

        if (updatedSubData[subIndex]) {
            updatedSubData[subIndex].IsActive = value;
        }

        updatedItem.subData = updatedSubData;
        updatedShowData[index] = updatedItem;
        setShowData(updatedShowData)
    };

    const handleChangeCheck = (checked, index, type) => {
        const updatedShowData = [...showData];
        const updatedItem = { ...updatedShowData[index] };
        let updatedSubData = [];
        if (type == "first") {
            updatedSubData = updatedItem.subData?.map((val, i) => ({ ...val, IsActive: 0 }))
        } else if (type == "second") {
            updatedSubData = updatedItem.subData?.map((val, i) => ({ ...val, IsActive: 1 }))
        }
        updatedItem.subData = updatedSubData;
        updatedShowData[index] = updatedItem;
        setShowData(updatedShowData)
    }

    const sendOTPRequest = () => {
        const obj = {
            strOTPType: "UR",
            intCompanyId: loginData?.intCompanyID,
            intRoleID: roleId,
            intSaveType: 1,
            intOTPSendType: selApprAuth?.id
        }
        oTPForUserRoleRight(obj).then((res) => {
            if (res?.Status == true) {
                setOTP(res.OTP)
                setOtpModal(true)
            } else {
                setOTP("")
                updateAlertError({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            updateAlertError({ show: true, msg: err })
            console.log("Error:", err)
        })
    }
    const transformedObject = (arr) => {
        const result = {};
        arr.forEach(item => {
            item.subData.forEach(person => {
                Object.keys(person).forEach(key => {
                    if (!result[key]) {
                        result[key] = '';
                    }
                });

                Object.keys(person).forEach(key => {
                    result[key] += person[key] + '^';
                });
            });
        });
        Object.keys(result).forEach(key => {
            result[key] = result[key].slice(0, -1);
        });
        return result
    }
    const saveApi = () => {
        const newObj=transformedObject(showData)
        const obj = {
            RoleID: roleId,
            JobIDs: newObj?.JobID,
            IsActives: newObj?.IsActive,
            UserID: loginData?.intUserID,
            BaseUserID: loginData?.intUserID
        }
        userRREditRightsSave(obj).then((res) => {
            if (res?.status == 'Success') {
                setIsOpen({ ...isOpen, open: true, message: bum.roleRightsSavedSuccessfullyNl || "Role Rights\nSaved Successfully!" })
            } else {
                setSaveError({ ...saveError, error: true, message: res.Message })
            }
        }).catch((err) => {
            console.log("Error:", err)
            setSaveError({ ...saveError, error: true, message: err })
        })
    }

    const onSave = () => {
        if (otpOnUserRights == 1) {
            if (selApprAuth === "") {
                updateAlertError({ show: true, msg: bum.selectApprovalAuthority || "Select Approval Authority", nextId: "UmAppAuth" })
            } else {
                sendOTPRequest()
            }
        } else {
            saveApi()
        }
      
    }
    return (
        <>
            <Modal headTxt={bum.editRights || `Edit Rights`} modalStyle={modalStyle} modalClass={'booking-popup'} width={'45%'} closeId={"closeButton"} updateModal={updateModal} sx={{ marginTop: '20px' }}>
                <Stack style={{ margin: "8px 10px", marginRight: "0px", marginBottom: "0px" }}>
                    <Box className='EditRightsModalDes scrollBlue'>
                        {
                            showData?.map((item, i) => {
                                return (

                                    <Box className='EditRightsModal'>
                                        <Box className='editRightsCheck'>
                                            {
                                                showSubData === i + 1 ?
                                                    <KeyboardArrowDown id={`EditRightDownArrow-${i}`} tabIndex={0} style={{ cursor: "pointer", color: "#444", fontSize: "20px" }} onKeyDown={(e) => arrowClick(e, `EditRightsLabelCheck-${i}`, i == 0 ? "EditRightSave" : `EditRightArrow-${i - 1}`, () => { setShowSubData(""); focusElemnt(showData?.length === i + 1 ? "EditRightsAppAuth" : `EditRightArrow-${i + 1}`) })} onClick={() => setShowSubData("")} />
                                                    :
                                                    <KeyboardArrowRight id={`EditRightArrow-${i}`} tabIndex={0} style={{ cursor: "pointer", color: "#444", fontSize: "20px" }} onKeyDown={(e) => arrowClick(e, showSubData === i + 1 ? `EditRightInsideCheck-${i}` : showData.length === i + 1 ? "EditRightsAppAuth" : `EditRightArrow-${i + 1}`, i == 0 ? "EditRightSave" : showSubData == i  ? `EditRightInsideCheck-${showData[i-1].subData.length-1}` : `EditRightArrow-${i - 1}`, () => { rightClick(i); focusElemnt(`EditRightsLabelCheck-${i}`) })} onClick={() => rightClick(i)} />
                                            }
                                            <Box>
                                                {
                                                    item.subData?.every((val) => val.IsActive === 1) ?
                                                        <Checkbox checked={true} id={`EditRightsLabelCheck-${i}`} sx={{ padding: '2px 0px 4px 0px' }} onKeyDown={(e) => { navigation3(e, `EditRightInsideCheck-0`, `EditRightDownArrow-${i}`, () => { }) }}
                                                            onChange={(e) => handleChangeCheck(e.target.checked, i, "first")}
                                                        /> :
                                                        item.subData?.every((val) => val.IsActive === 0) ? <Checkbox checked={false} id={`EditRightsLabelCheck-${i}`} sx={{ padding: '2px 0px 4px 0px' }} onKeyDown={(e) => { navigation3(e, `EditRightInsideCheck-0`, `EditRightDownArrow-${i}`, () => { }) }}
                                                            onChange={(e) => handleChangeCheck(e.target.checked, i, "second")} />
                                                            : <span style={{ cursor: "pointer" }} id={`EditRightsLabelCheck-${i}`} tabIndex={0} onKeyDown={(e) => { navigation3(e, `EditRightInsideCheck-0`, `EditRightDownArrow-${i}`, () => { }) }}
                                                                onClick={(e) => handleChangeCheck(e.target.checked, i, "second")}>
                                                                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit half--checkbox css-1cw4hi4" focusable="false" aria-hidden="true" viewBox="0 0 24 24" style={{ width: "20px", height: "24px" }}><path d="m21 4c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-16.5.5h15v15h-15zm11.75 6.752h-8.5c-.414 0-.75.336-.75.75s.336.75.75.75h8.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z" fill="#777"></path></svg>
                                                            </span>
                                                }
                                            </Box>
                                        </Box>
                                        <Box className='editRightsBox' style={{ border: showSubData === i + 1 ? "1px solid #A6A8AB80" : "" }}>
                                            <Box className='editRightHeading'>
                                                {item.MasterName}
                                            </Box>
                                            {
                                                showSubData === i + 1 ?
                                                    <>
                                                        {
                                                            item.subData?.map((val, index) => {
                                                                return (
                                                                    <Box className='insideBox'>
                                                                        <FormControlLabel
                                                                            value="end"
                                                                            className='checkbox'
                                                                            control={<Checkbox checked={val.IsActive == 1} id={`EditRightInsideCheck-${index}`} sx={{ padding: '4px 8px 4px 8px' }} />}
                                                                            onKeyDown={(e) => {
                                                                                navigation3(e, item.subData.length === index + 1 ? `EditRightArrow-${i + 1}` : `EditRightInsideCheck-${index + 1}`, index == 0 ? `EditRightsLabelCheck-${i}` : `EditRightInsideCheck-${index - 1}`, () => { })
                                                                            }}
                                                                            label={
                                                                                <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                                                                    {val.JobName}
                                                                                </Typography>
                                                                            }
                                                                            onChange={(e) => {
                                                                                subDataHandleChange(e.target.checked ? 1 : 0, i, index)
                                                                            }}
                                                                            labelPlacement="end"
                                                                        />
                                                                    </Box>
                                                                )
                                                            })
                                                        }
                                                    </>
                                                    : ""
                                            }
                                        </Box>
                                    </Box>
                                )
                            })
                        }
                    </Box>
                </Stack>
                <Divider />
                <Stack className="itemButtons BranchAndUsrBottomSec">
                    <Box className='reportButton' sx={{ display: 'flex', justifyContent: "space-between", padding: "12px 16px", paddingBottom: "0px", gap: "12px" }}>
                        {otpOnUserRights == 1 ? <Box>
                            <Item sx={sx.itemsx} style={{ width: "350px" }} className={'input--wrapper'}>
                                <DropDownOA
                                    id={"EditRightsAppAuth"}
                                    data={ApprAuthority || []}
                                    defaultvalue={selApprAuth?.name || ''}
                                    width="100%"
                                    searchPlaceholder={bum.searchBranchName || `Search Branch Name`}
                                    label={bum.approvalAuthority || "Approval Authority"}
                                    dataKey={`name`}
                                    idKey={`id`}
                                    nextId={"EditRightCancel"}
                                    field={'compulsory'}
                                    direction='up'
                                    prevId={`EditRightArrow-${showData?.length - 1}`}
                                    onSelect={(value) => setSelApprAuth(value)}
                                />
                            </Item>
                        </Box> : ""}
                        <Box style={{ display: "flex", gap: "15px" }}>
                            <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "EditRightSave", "EditRightsAppAuth", () => { })}>
                                <Button id={"EditRightCancel"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => { updateModal(false, "CreateNewUser"); focusElemnt("URRCatagoryNameInp") }}>
                                    {bum.cancel || "CANCEL"}
                                </Button>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, `EditRightArrow-0`, "EditRightCancel", () => { })}>
                                <Button variant="contained" id="EditRightSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                                    onClick={() => onSave()}
                                >
                                    {bum.save || "Save"}
                                </Button>
                            </Item>
                        </Box>
                    </Box>
                    {
                        otpOnUserRights == 1 ?
                            <Box style={{ marginLeft: "16px", marginBottom: "4px", display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "13px", marginTop: "5px" }}>
                                <InfoIcon style={{ color: "#0086FF" }} />
                                <span style={{ color: "#1E59A7" }}>{bum.otpWillSendToManagementAsPerSelection || "OTP will send to the Management as per Selection"}</span>
                            </Box>
                            : ""
                    }
                </Stack>
            </Modal>
            {OtpModal ? <OTPModal saveApi={saveApi} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} /> : ""}
             <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); onLoad(); updateModal(false, "");userRollRightEditRights({RoleID: loginData?.intRoleID,IsLuggage: 0})}} open={isOpen?.open} title={isOpen?.message} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setSaveError({ ...saveError, error: false })} isError={true} open={saveError.error} title={saveError?.message} /> 
        </>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError, updateAlertError, userRREditRightsSave,userRollRightEditRights
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRightsModal)